import ServiceAPI from '@/views/Listados/Planilla_Uso_Diario/Grafico_Consumo_Corral/service'

const state = {
  dataGrafico: [],
  corralesDisponibles: [],
  loading: false,
  error: null,
  filtro: {
    fecha_desde: null,
    fecha_hasta: null,
    corralesArray: [],
    id_corrales: [],
  }
}

const mutations = {
  SET_DATA_GRAFICO(state, data) {
    state.dataGrafico = data
  },
  SET_CORRALES_DISPONIBLES(state, corrales) {
    state.corralesDisponibles = corrales
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_FILTRO(state, filtro) {
    state.filtro = { ...state.filtro, ...filtro }
  },
  CLEAR_DATA(state) {
    state.dataGrafico = []
    state.corralesDisponibles = []
    state.error = null
  }
}

const actions = {
  async fetchGraficoData({ commit }, filtro) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const response = await ServiceAPI.getDatosChart(filtro)
      const data = response.data.grafico_consumo_corral || []

      commit('SET_DATA_GRAFICO', data)
      commit('SET_FILTRO', filtro)

      // Extraer corrales disponibles
      const corrales = [...new Set(data.map(item => item.NRO_CORRAL))].sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
      )
      commit('SET_CORRALES_DISPONIBLES', corrales)

      commit('SET_LOADING', false)
      return { success: true, data }
    } catch (error) {
      commit('SET_ERROR', error)
      commit('SET_LOADING', false)
      return { success: false, error }
    }
  },

  clearGraficoData({ commit }) {
    commit('CLEAR_DATA')
  }
}

const getters = {
  getDataGrafico: (state) => state.dataGrafico,
  getCorralesDisponibles: (state) => state.corralesDisponibles,
  getDataByCorral: (state) => (nroCorral) => {
    return state.dataGrafico.filter(item => item.NRO_CORRAL === nroCorral)
  },
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
  getFiltro: (state) => state.filtro
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
